var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#smiley';
                    var viewUrl = 'svg/icons.svg#view-smiley';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 122.88 122.88',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };